<template>
  <HeaderApp />
  <div class="mt-14"></div>

  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      (isHide == true
        ? '  '
        : $store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
    id="printDev"
  >
    <InvoiceHeader invoice_type="purchases_list" v-if="isHide == true" />
    
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("purchases_list") }}
      </h1>
    </div>

    <!-- Filters and Controls -->
    <div
      class="px-6 py-4 border-b border-gray-200 dark:border-gray-700"
      v-if="isHide != true"
    >
      <div
        class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4"
      >
        <!-- Search and Print Actions -->
        <div class="flex items-center space-x-4">
          <BaseInput
            :modelValue="$store.state.purchase_list.search"
            @update:modelValue="handleSearchInput"
            :placeholder="$t('search')"
            :prefixIcon="'fa-solid fa-search'"
            class="w-40 md:w-full"
          />
          <BaseInput
            :modelValue="$store.state.purchase_list.searchBarcode"
            @update:modelValue="handleBarcodeSearchInput"
            :placeholder="$t('search_by_purchased_item_barcode')"
            :prefixIcon="'fa-solid fa-barcode'"
            class="w-40 md:w-full"
          />
          <button
            class="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200 no-print"
            @click="printReportFunc"
            id="button_print"
            v-if="$store.getters['checkPrintAccess']"
          >
            <i class="fa-solid fa-print mr-2"></i>
            {{ $t("print") }}
          </button>
        </div>

        <!-- Column Selection -->
        <div class="flex items-center space-x-4">
          <CustomMultiSelect
            v-model="selectedHeaders"
            :options="headers"
            track-by="value"
            label="text"
            :placeholder="$t('columns')"
            :header-text="$t('which_columns_to_display')"
            @update:modelValue="printCall"
          />
          <div class="w-0.5"></div>
            <button
              @click="resetToDefaultHeaders"
              class=" group inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br  text-blue-600 dark:text-blue-400 rounded-xl border border-blue-200 dark:border-gray-600 hover:from-blue-100 hover:to-indigo-200 dark:hover:from-gray-600 dark:hover:to-gray-700 hover:shadow-lg hover:shadow-blue-200/50 dark:hover:shadow-gray-900/50 hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 backdrop-blur-sm"
              :title="$t('reset_to_default')"
            >
              <i class="fa fa-refresh text-sm group-hover:rotate-180 transition-transform duration-500"></i>
            </button>
        </div>
      </div>
    </div>

    <!-- Table Container -->
    <div class="px-6 py-4">
      <div
        class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
      >
        <EasyDataTable
          :key="`table-${isDark ? 'dark' : 'light'}`"
          v-model:server-options="serverOptions"
          :headers="showHeaders"
          :items="items"
          :server-items-length="serverItemsLength"
          :loading="isLoadingData"
          :alternating="false"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :hide-footer="isHide"
          :rows-items="[25, 50, 100, serverItemsLength]"
          rows-per-page="15"
          :table-class-name="isDark ? 'modern-dark-table' : ''"
        >
          <template #default="{ column, sortDirection }">
            <div
              :class="`flex items-center space-x-2 ${
                $store.getters['isRtl'] ? 'justify-end' : 'justify-start'
              }`"
            >
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{
                column.label
              }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
              </span>
            </div>
          </template>
          <template #item-actions="item">
            <div class="flex items-center justify-center space-x-2">
              <a
                :href="'edit-purchase/' + item.pu_id"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '17',
                    action: 'detail',
                  })
                "
                class="inline-flex items-center p-2 text-green-600 bg-green-50 hover:bg-green-100 rounded-lg transition-colors duration-200"
                :title="$t('view_details')"
              >
                <i class="fa-solid fa-eye text-sm"></i>
              </a>
              <button
                @click="deleteItem(item.pu_id)"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '17',
                    action: 'delete',
                  })
                "
                class="inline-flex items-center p-2 text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors duration-200"
                :title="$t('delete')"
              >
                <i class="fa-solid fa-trash text-sm"></i>
              </button>
            </div>
          </template>
          <template #item-pu_paid_amount="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.pu_paid_amount) }}
              </span>
            </div>
          </template>
          <template #item-pu_total_amount="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.pu_total_amount) }}
              </span>
            </div>
          </template>
          <template #item-pu_due_amount="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.pu_due_amount) }}
              </span>
            </div>
          </template>
          <template #item-cur_id="item">
            <span
              class="inline-flex items-center px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200 rounded-md"
            >
              {{ $t(item.currency.cur_name) }}
            </span>
          </template>
          <template #item-id="item">
            <span class="text-gray-900 dark:text-gray-100 font-medium">
              {{ $t(item.users.name) }}
            </span>
          </template>
          <template #item-pu_main_currency_price="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.pu_main_currency_price) }}
              </span>
            </div>
          </template>
          <template #item-su_id="item">
            <span class="text-gray-900 dark:text-gray-100 font-medium">
              {{ item.suplier.su_name }}
            </span>
          </template>
          <template #loading>
            <div class="flex justify-center items-center py-8">
              <div
                class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
              ></div>
              <span class="ml-3 text-gray-600 dark:text-gray-400"
                >{{ $t("loading") }}...</span
              >
            </div>
          </template>
          <template #item-pu_note="item">
            <span
              v-if="item.pu_note == null || item.pu_note == ''"
              class="text-gray-400 text-sm"
            >
              —
            </span>
            <span
              v-else
              class="text-gray-900 dark:text-gray-100 max-w-xs truncate"
              :title="item.pu_note"
            >
              {{ item.pu_note }}
            </span>
          </template>
          <template #item-created_at="item">
            <span class="text-gray-600 dark:text-gray-400 text-sm">
              {{ formatDate(item.created_at) }}
            </span>
          </template>
          <template #empty-message>
            <div class="text-center py-12">
              <i class="fa-solid fa-box-open text-4xl text-gray-400 mb-4"></i>
              <p class="text-gray-500 dark:text-gray-400 text-lg font-medium">
                {{ $t("no_data_found") }}
              </p>
              <p class="text-gray-400 dark:text-gray-500 text-sm mt-2">
                {{ $t("try_adjusting_your_search_criteria") }}
              </p>
            </div>
          </template>
          <template
            #pagination="{
              prevPage,
              nextPage,
              isFirstPage,
              isLastPage,
              currentPaginationNumber,
              maxPaginationNumber,
            }"
          >
            <button :disabled="isFirstPage" @click="goToPage(1)">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-right'
                    : ' fa-angle-double-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-right'
                    : ' fa-angle-left ')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              v-for="page in getVisiblePages(
                currentPaginationNumber,
                maxPaginationNumber
              )"
              :key="page"
              @click="goToPage(page)"
              :class="getPageButtonClasses(page, currentPaginationNumber)"
            >
              {{ page }}
            </button>

            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              :disabled="isLastPage"
              @click="goToPage(maxPaginationNumber)"
            >
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-left'
                    : ' fa-angle-double-right')
                "
              ></i>
            </button> </template
        ></EasyDataTable>
      </div>
    </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import CustomMultiSelect from "../../components/Inputs/CustomMultiSelect.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import { formatNumber } from "../../utils/functions";
// eslint-disable-next-line no-unused-vars
import { Header, ServerOptions, Item } from "vue3-easy-data-table";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import "../../assets/css/modern-table.css";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    CustomMultiSelect,
    ConfirmDialogue,
    ResultDialog,
    InvoiceHeader,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      pu_id: "",
      re_note: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      created_at: "",
      items: [],
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      isHide: false,
      selectedHeaders: [],
      columnsControl: false,
    };
  },
  created() {
    this.getData();
    this.loadSelectedHeaders();
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.purchase_list.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.purchase_list.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("purchase_list/SET_DELETE_SUCCESS", false);
      }
    },
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
    headers: {
      handler() {
        // When headers change, update selectedHeaders to match
        if (this.headers && this.headers.length > 0) {
          this.loadSelectedHeaders();
        }
      },
      immediate: true
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.purchase_list.isShowResultDialog;
    },

    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.purchase_list.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.purchase_list.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.purchase_list.isBtnEditLoading;
    },
    headers() {
      var listHeader = [
        //pu_id,st_id,pu_total_amount,pu_paid_amount,pu_total_amount,pu_due_amount,in_status,in_main_currency_price,admin

        { text: this.$t("purchase_id"), value: "pu_id", sortable: true },
        {
          text: this.$t("total_price"),
          value: "pu_total_amount",
          sortable: true,
        },
        {
          text: this.$t("discount"),
          value: "pu_discount",
          sortable: true,
        },
        {
          text: this.$t("paid_amount"),
          value: "pu_paid_amount",
          sortable: true,
        },
        { text: this.$t("due_amount"), value: "pu_due_amount", sortable: true },
        { text: this.$t("currency_type"), value: "cur_id", sortable: true },
        {
          text: this.$t("dolar_price"),
          value: "pu_main_currency_price",
          sortable: true,
        },
        { text: this.$t("suplier"), value: "su_id", sortable: true },
        { text: this.$t("box"), value: "box.bo_name", sortable: true },
        { text: this.$t("admin"), value: "id", sortable: true },
        { text: this.$t("note"), value: "pu_note", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
      //if isHide is true then hide some columns actions,
      if (this.isHide == true) {
        listHeader = listHeader.filter((item) => item.value !== "actions");
      }
      return listHeader;
    },
    showHeaders() {
      var temp = [];
      //cretae a for check all selectedHeaders add to temp
      for (let i = 0; i < this.selectedHeaders.length; i++) {
        for (let j = 0; j < this.headers.length; j++) {
          if (this.selectedHeaders[i].text == this.headers[j].text) {
            temp.push(this.headers[j]);
          }
        }
      }

      if (temp.length == 0) {
        temp = this.headers;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.selectedHeaders = temp;
      }

      return temp;
    },
  },
  mounted() {
    // First load when the component is mounted
    this.loadFromServer();
    this.loadSelectedHeaders();
  },
  methods: {
    handleSearchInput(value) {
      this.$store.commit('purchase_list/SET_SEARCH', value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    handleBarcodeSearchInput(value) {
      this.$store.commit('purchase_list/SET_SEARCH_BARCODE', value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    printReportFunc() {
      this.isHide = true;
      //wait 1 second
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;

        // Replace the body's innerHTML with the print contents
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        // Set direction based on the parameter
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }

        // Print the content
        window.print();  // Adjust the timeout as needed
        //reload page
      }, 100);
      //print element id invoice_print
    },
    getVisiblePages(currentPage, totalPages) {
      const numVisibleButtons = 3; // Adjust this number based on your design preference
      const pages = [];

      // Display pages 1 to numVisibleButtons (e.g., 1, 2, 3)
      if (currentPage <= Math.floor(numVisibleButtons / 2) + 1) {
        for (let i = 1; i <= Math.min(totalPages, numVisibleButtons); i++) {
          pages.push(i);
        }
      }
      // Display pages around the current page (e.g., 1, ..., 10, ..., 20)
      else {
        const startPage = Math.max(
          1,
          currentPage - Math.floor(numVisibleButtons / 2)
        );
        const endPage = Math.min(totalPages, startPage + numVisibleButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }

      return pages;
    },

    // Function to get Tailwind CSS classes for each page button
    getPageButtonClasses(page, currentPage) {
      return {
        "bg-blue-500 text-white": page === currentPage,
        "bg-gray-300 text-gray-700 hover:bg-gray-400": page !== currentPage,
        "p-2 rounded-md mx-1": true, // Adjust padding and rounding based on your design
      };
    },

    goToPage(page) {
      // Implement your logic to update the current page
      //update page
      this.serverOptions.page = page;
      this.loadFromServer();
    },
    formatNumber(number) {
      return formatNumber(number);
    },
    async loadFromServer() {
      this.loading = true;

      var tempObj = { ...this.serverOptions };
      //add new field to object search
      tempObj.search = this.$store.state.purchase_list.search;
      tempObj.searchBarcode = this.$store.state.purchase_list.searchBarcode;
      const res = await this.$store.dispatch("purchase_list/getItems", tempObj);

      this.items = res.data.data;
      this.serverItemsLength = res.data.total;
      this.loading = false;
    },
    routeTo(href) {
      //go href and refresh page
      this.$store.commit("edit_sale/SET_EDIT_SALE_CLEAR", {});
      this.$router.push({ path: href }).catch(() => {});
      //clear edit_sale state module
    },
    formatDate(date) {
      return formatDate(date);
    },
    getData() {
      //this.$store.dispatch("purchase_list/getItems");
    },
    async AddItem() {
      //check form validation
      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.pu_id, "add", this.rules).isError ||
        this.checkRulesIsError(this.re_note, "add", this.rules).isError
      ) {
        return;
      }
      this.$store.state.purchase_list.isBtnLoading = true;
      var res = await this.$store.dispatch("purchase_list/addNewItem", {
        pu_id: this.pu_id,
        re_note: this.re_note,
        created_at: this.created_at,
      });
      if (res.status == 200) {
        this.pu_id = "";
        this.re_note = "";
        this.isSubmited = false;
      }
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        //remove item from items array when pu_id is equal to id
        this.items = this.items.filter((item) => item.pu_id !== id);
        await this.$store.dispatch("purchase_list/deleteItem", id);
        this.loadFromServer();
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      this.current.created_at = this.current.created_at
        .toString()
        .split("T")[0];
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.pu_id, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.re_note, "edit", this.rules).isError
      ) {
        return;
      }
      this.$store.state.purchase_list.isBtnEditLoading = true;
      var res = await this.$store.dispatch("purchase_list/editItem", {
        pu_id: this.current.pu_id,
        re_note: this.current.re_note,
        created_at: this.current.created_at,
      });

      this.isSubmitedEdit = false;
      this.$store.state.purchase_list.isBtnEditLoading = false;
      if (res.status == 200) {
        this.$refs.editModal.hide();
        this.loadFromServer();
      }
    },
    loadSelectedHeaders() {
      // Load selected headers from localStorage
      const savedHeaders = localStorage.getItem('purchaseListSelectedHeaders');
      if (savedHeaders) {
        try {
          const parsedHeaders = JSON.parse(savedHeaders);
          // Filter to only include headers that exist in current headers list
          this.selectedHeaders = this.headers.filter(header => 
            parsedHeaders.some(saved => saved.value === header.value)
          );
        } catch (error) {
          console.error('Error loading saved headers:', error);
          this.selectedHeaders = [...this.headers];
        }
      } else {
        // If no saved headers, select all by default
        this.selectedHeaders = [...this.headers];
      }
    },
    saveSelectedHeaders() {
      // Save selected headers to localStorage
      try {
        localStorage.setItem('purchaseListSelectedHeaders', JSON.stringify(this.selectedHeaders));
      } catch (error) {
        console.error('Error saving headers:', error);
      }
    },
    printCall(selectedHeaders) {
      // Handle column selection changes
      if (selectedHeaders && Array.isArray(selectedHeaders)) {
        this.selectedHeaders = selectedHeaders;
        this.saveSelectedHeaders();
      }
    },
    resetToDefaultHeaders() {
      // Reset to select all headers
      this.selectedHeaders = [...this.headers];
      this.saveSelectedHeaders();
    },
  },
};
</script>
